import { render, staticRenderFns } from "./face.vue?vue&type=template&id=ab161e68&"
import script from "./face.vue?vue&type=script&lang=js&"
export * from "./face.vue?vue&type=script&lang=js&"
import style0 from "./face.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports